//istanbul ignore file MOTIVE_EXCEPTION
import { useStore } from '../useStore/useStore';
import { StyleContext } from '../../contexts/styleContext';

export const useStyle = () => {
    const styleContext = useStore(StyleContext);
    return styleContext.tokens;
};
